import React from 'react';

const ICON_PROPS = {
  width: 18, height: 18, viewBox: '0 0 24 24',
  fill: 'none', stroke: 'currentColor', strokeWidth: 2,
  strokeLinecap: 'round', strokeLinejoin: 'round',
};

export const IconUser = () => (
  <svg {...ICON_PROPS} aria-hidden>
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

export const IconBell = () => (
  <svg {...ICON_PROPS} aria-hidden>
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </svg>
);

export const IconLock = () => (
  <svg {...ICON_PROPS} aria-hidden>
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

export const IconCard = () => (
  <svg {...ICON_PROPS} aria-hidden>
    <rect x="2" y="5" width="20" height="14" rx="2" ry="2" />
    <line x1="2" y1="10" x2="22" y2="10" />
  </svg>
);

const NAV_ICONS = {
  'personal-info': IconUser,
  'description': IconBell,
  'notifications': IconBell,
  'security': IconLock,
  'payments': IconCard,
};

/** Profile Settings nav icon, looked up by tab id — shared between the
 * teacher (ProfileSettings.jsx) and student (StudentProfileSettings.jsx)
 * nav lists so both use the exact same icon set. */
export const NavIcon = ({ id }) => {
  const Icon = NAV_ICONS[id];
  return Icon ? <Icon /> : null;
};
